import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _createReducer;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { FETCH_FINANCE_ORGANIZATIONS_REQUEST, FETCH_FINANCE_ORGANIZATIONS_SUCCESS, FETCH_FINANCE_ORGANIZATIONS_FAILURE, FETCH_FINANCE_ORGANIZATION_REQUEST, FETCH_FINANCE_ORGANIZATION_SUCCESS, FETCH_FINANCE_ORGANIZATION_FAILURE } from 'actionTypes';
import createReducer from './createReducer';
var initialState = {
  entities: [],
  ids: [],
  organization: {},
  isFetching: false,
  isRequestFailed: false,
  isLoaded: false
};
var ORGANIZATIONS = createReducer(initialState, (_createReducer = {}, _defineProperty(_createReducer, FETCH_FINANCE_ORGANIZATIONS_REQUEST, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isFetching: true,
    isRequestFailed: false,
    isLoaded: false
  });
}), _defineProperty(_createReducer, FETCH_FINANCE_ORGANIZATIONS_SUCCESS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    entities: action.payload.entities,
    ids: action.payload.ids,
    isFetching: false,
    isLoaded: true
  });
}), _defineProperty(_createReducer, FETCH_FINANCE_ORGANIZATIONS_FAILURE, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isFetching: false,
    isRequestFailed: true
  });
}), _defineProperty(_createReducer, FETCH_FINANCE_ORGANIZATION_REQUEST, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    organization: _objectSpread(_objectSpread({}, state.organization), {}, _defineProperty({}, action.payload.organizationSlug, _objectSpread(_objectSpread({}, action.payload), {}, {
      isFetching: true,
      isRequestFailed: false,
      isLoaded: false
    })))
  });
}), _defineProperty(_createReducer, FETCH_FINANCE_ORGANIZATION_SUCCESS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    organization: _objectSpread(_objectSpread({}, state.organization), {}, _defineProperty({}, action.payload.organizationSlug, {
      data: action.payload.data,
      isFetching: false,
      isRequestFailed: false,
      isLoaded: true
    }))
  });
}), _defineProperty(_createReducer, FETCH_FINANCE_ORGANIZATION_FAILURE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    organization: _objectSpread(_objectSpread({}, state.organization), {}, _defineProperty({}, action.payload.organizationSlug, _objectSpread(_objectSpread({}, action.payload), {}, {
      isFetching: false,
      isRequestFailed: true,
      isLoaded: false
    })))
  });
}), _createReducer));
export default ORGANIZATIONS;